module.exports = __webpack_public_path__ + "img/64e79842e86ad09a621d5417_logotype-lockup.326f9f20.svg";